export default __webpack_public_path__ + "static/media/yoga_girl.b6820e17.svg";